
import { Component, Prop, Vue } from 'vue-facing-decorator';

@Component({})
export default class extends Vue {
  /** 一行礼物，直接改它上面的字段（同 message-row 的约定），只把删除 emit 出去 */
  @Prop()
  modelValue: any;

  /** 付费会员等级，父组件用 getPaidLevelList 拉一次传下来 */
  @Prop({
    default() {
      return []
    }
  })
  levelList: any[];

  /** couponId -> 券名：detail 只回 couponId、不带 couponInfo 关联，券名得反查 */
  @Prop({
    default() {
      return {}
    }
  })
  couponMap: Record<string, string>;

  /**
   * 能新配的方式。
   * 卡密(1) 暂时隐藏 —— 卡密池的导入/作废界面还没做，配了库存也恒为 0、卖不出去。
   * 接口通知(4) 的 UI 本来就没做。两种都只是不在下拉里，后端和已有数据不受影响。
   */
  typeList = [
    { label: "优惠券", value: 2 },
    { label: "会员", value: 3 },
  ];

  /** 不提供「新配」、但存量数据必须能显示和保留的方式 */
  frozenTypeNames = {
    1: "卡密（暂未开放）",
    4: "第三方接口通知",
  };

  /**
   * 下拉选项 = 可选的方式；如果这一行现在就是冻结类型，再把当前值加进去。
   * 只加当前值，不是无条件加 —— 所以新行永远选不到卡密/接口通知，
   * 存量行则能显示出自己的类型并换走。
   */
  get typeOptions() {
    let options = this.typeList.slice();
    let frozenName = this.frozenTypeNames[this.modelValue.type];
    if (frozenName) {
      return [{ label: frozenName, value: this.modelValue.type }].concat(options);
    }
    return options;
  }

  created() {
    /**
     * 新加的行不带 type（send-dialog 不硬编码，免得和这里的可选列表脱节），
     * 这里补成第一个可选的方式。
     * 不能覆盖冻结类型 —— 那是存量配置，要原样带 id 回传。
     */
    let current = this.modelValue.type;
    let usable = this.frozenTypeNames[current] || this.typeList.some((item) => item.value == current);
    if (!usable) {
      this.modelValue.type = this.typeList[0].value;
    }
  }

  async chooseCoupon() {
    try {
      let coupon = await this.$chooseCoupon();
      /**
       * 正常返回的是整行券，只有它才带 id。
       * 拿到别的形状（历史上是 dialog key 撞了、返回 [{ msg: '已唤起' }]）时直接退出，
       * 别把 couponId 写成 undefined —— 那会静默变成一个「没选券」的礼物。
       */
      if (!coupon || !coupon.id) return;
      this.modelValue.couponId = coupon.id;
    } catch (e) {
      // 用户取消
    }
  }

  /**
   * 换类型时把别的类型那组字段清掉。
   * 后端 ValidateIfAndStrip 只是把不相关字段从 DTO 上 delete 掉，而 TypeORM 对 undefined
   * 不写进 UPDATE SET —— 所以换类型并不会清掉库里上一组的值。不在这里清干净，
   * 就会把上一组的值一路带过去，界面上还看不出问题。
   */
  changeType() {
    let row = this.modelValue;
    delete row.couponId;
    delete row.vipLevelId;
    delete row.vipMonth;
    /** 张数/时长必须有值，空着后端 @Min(1) 会拦 */
    if (row.type == 2) row.count = row.count || 1;
    if (row.type == 3) row.vipMonth = row.vipMonth || 1;
  }
}
